/**
 * Node's fetch cannot resolve relative URLs. Client components that run during SSR
 * (e.g. useSuspenseQuery) need an absolute URL when `fetch` runs on the server.
 * Browser requests keep the original relative `url`.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export function resolveRequestUrl(url: string): string {
	if (url.startsWith("http://") || url.startsWith("https://")) {
		return url;
	}
	if (typeof window !== "undefined") {
		return url;
	}

	const fromEnv = process.env.NEXT_PUBLIC_APP_URL?.replace(/\/+$/, "");
	if (fromEnv) {
		return new URL(url, `${fromEnv}/`).href;
	}

	return new URL(url, "http://localhost:3000/").href;
}
